import { auth } from '@/api'
import router from '@/router'
import { removeChatWootScript } from '@/utils/snippets'
import getFieldFromToken from '@/utils/getFieldFromToken'
import legacyRouteMigrations from '@/router/legacyRouteMigrations'
import dayjs from "dayjs"

export default {
  login(ctx, { payload, company }) {
    return auth.login(payload)
      .then(({ data }) => {
        return ctx.dispatch('setToken', {
          token: data.data.token,
          expire: data.data.exp,
          company,
        })
      })
      .catch((err) => {
        throw err
      })
  },
  setToken(ctx, {
    token,
    expire,
    company,
  }) {
    localStorage.setItem('token', token)
    localStorage.setItem('tokenExp', dayjs().add(expire, 's').format())
    const supplierFromToken = getFieldFromToken('sup')
    if (supplierFromToken) {
      return router.push({
        name: 'pre-orders',
        params: { company: supplierFromToken },
      })
    }

    const uid = getFieldFromToken('uid')

    return ctx.dispatch('companies/getUserCompanies', uid, { root: true }).then((companies) => {
      const userRequestUrl = sessionStorage.getItem('userRequestUrl')
      if (userRequestUrl) {
        sessionStorage.removeItem('userRequestUrl')
        try {
          let userRequest = JSON.parse(userRequestUrl)
          // The route name/params can be stale if they were stored by an
          // older app build (e.g. a tab left open overnight across a deploy
          // that renamed routes) — translate known old shapes to the
          // current one. See router/legacyRouteMigrations.js.
          const migrate = legacyRouteMigrations[userRequest.name]
          if (migrate) {
            const migrated = migrate(userRequest.params)
            userRequest = { ...userRequest, name: migrated.name, params: migrated.params }
          }
          const requestCompany = userRequest.params.company
          if (companies.some(({ slug }) => slug === requestCompany) && router.hasRoute(userRequest.name)) {
            router.resolve(userRequest)
            return router.push(userRequest)
          }
        } catch (e) {
          // Unrecognized/unresolvable stale route — fall through to the default redirect below.
        }
      }

      if (company && companies.some(({ slug }) => slug === company)) {
        return router.push({
          name: 'pre-orders',
          params: { company: company },
        })
      }
      if (!companies.length || companies.length > 1) {
        return router.push({ name: 'home' })
      }

      if (companies.length > 1) {
        return router.push({ name: 'home' })
      }

      return router.push({
        name: 'pre-orders',
        params: { company: companies[0].slug },
      })
    })
  },
  refreshToken() {
    return auth.refreshToken().then(({ data }) => {
      localStorage.setItem('token', data.data.token)
      localStorage.setItem('tokenExp', dayjs().add(data.data.exp, 's').format())

      return data
    })
  },
  forgotPassword(context, formData) {
    return auth.forgotPassword(formData)
  },
  resetPassword(context, formData) {
    return auth.resetPassword(formData)
  },
  createAccount(context, formData) {
    return auth.createAccount(formData)
      .then(() => {
        router.push({ name: 'login' })
      })
      .catch((err) => {
        throw err
      })
  },
  getAccountData(context, payload) {
    return auth.getAccountData(payload)
  },
  setCompany(context, companySlug) {
    return auth.setCompany(companySlug).then(() => {
      localStorage.setItem('token', token)
      localStorage.setItem('tokenExp', dayjs().add(expire, 's').format())
      router.push({
        name: 'pre-orders',
        params: { company: companySlug },
      })
    })
  },
  async logout({ dispatch }, userId = null) {
    localStorage.removeItem('token')
    localStorage.removeItem('tokenExp')
    localStorage.removeItem('withEndCustomers')
    sessionStorage.removeItem('currentCompanySlug')
    if (userId) {
      localStorage.setItem(`${userId}-lastVisitedPage`, router.history.current.path)
    }
    // removeSmartLookScript()
    removeChatWootScript()
    await router.push({
      name: 'login',
      query: { force: 1 },
    })
    dispatch('resetAll', {}, { root: true })
  },
}
